import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import type { ICitaDiagnostico } from '@/modules/Asistencial/interfaces'
import type { IConfContratos, IConfContratosxservicios, IConfCups } from '@/modules/Contratacion/interfaces'
import type { IAuditoria } from '@/modules/Core/interfaces'
import type { ICitaAdmision } from '@/modules/Admision/interfaces/tablas/ICitaAdmision'
import type { ICitaAgendamiento } from '@/modules/Agendamiento/interfaces'
import type { IMediMedicamentosGenericos } from '@/modules/Farmacia/interfaces/tablas/IMediMedicamentosGenericos'
import type { IConfMaestra } from '@/modules/Configuracion/interfaces'
import type { IConfPersonasEmpleado, IConfPersonasEmpresa, IConfPersonasPaciente } from '@/modules/Administracion/interfaces'

export enum tipoordenes {
  'OTROS SERVICIOS' = 'OTROS SERVICIOS',
  REMISIONES = 'REMISIONES',
  LABORATORIOS = 'LABORATORIOS',
  PROCEDIMIENTOS = 'PROCEDIMIENTOS',
  DISPENSARIOS = 'DISPENSARIOS',
  RECETARIOS = 'RECETARIOS'
}

export interface ICitaOrdenesTecnologia extends IAuditoria {
  ciotId?: number
  ciotTipo?: tipoordenes
  cittId?: number | null
  ciagId?: number
  cocoId?: number
  ciotFechaInicio?: string
  ciotFechaFinal?: string
  ciotTipoAdmision?: string
  ciotTipoEstado?: string
  coppId?: number
  ciotCopago?: number
  ciotTotalValor?: number
  ciotOrigenTabla?: string
  ciotOrigenId?: number
  ciotFechaOrigen?: string
  ciotTipoRegimen?: number
  ciotTipoFinalidad?: number
  ciotTipoConceptoRecaudo?: number
  ciotTipoModalidadAtencion?: number
  ciotTipoGrupoServicios?: number
  ciotTipoCodigoServicios?: number
  ciotTipoOtrosServicios?: number
  ciotTipoIngresoUsuario?: number
  ciotFechaOrden?: string
  ciotMedOrden?: string
  ciotTipoCausa?: number
  ciotEntidadOrden?: string
  ciotMedTipoDocumento?: number
  ciotMedDocumento?: string
  ciotRegistroMedico?: string
  ciotFechaAutorizacion?: string
  ciotNitIpsOrigen?: string
  ciotNumeroAutorizacion?: string
  ciotVale?: string
  ciotServOrden?: string
  cocsId?: number
  contrato?: IConfContratos
  paciente?: IConfPersonasPaciente
  empleado?: IConfPersonasEmpleado
  admision?: ICitaAdmision
  contratoxservicio?: IConfContratosxservicios
  estadoRecetario?: string
  diagnosticos?: ICitaDiagnostico[]
  tecnologia?: ICitaTechnologiasSalud
  detalles?: ICitaOrdenesTecnologiaDetalle[]
  codigoservicio?: IConfMaestra
}

export interface ICitaOrdenesOrigen extends IAuditoria {
  ciooId?: number
  ciodId?: ICitaOrdenesTecnologiaDetalle
  ciooOrigenTipo: string
  ciooOrigenId: number
  ciooObservacion: string
  admision?: ICitaAdmision
  agendamiento?: ICitaAgendamiento
  estadoDerivado?: string
}

export interface ICitaOrdenesTecnologiaDetalle extends IAuditoria {
  ciodId?: number
  ciotId?: number
  ciodTipoOrden?: number
  cocuId?: number
  cocuPersonalizadoId?: number | null
  cupPersonalizado?: IConfCups
  ciodCantidad?: number
  ciodEstado?: string
  ciodObservacion?: string
  cups?: IConfCups
  search?: string
  orden?: ICitaOrdenesTecnologia
  origenesAdmisiones?: ICitaOrdenesOrigen[]
  origenesAgendamientos?: ICitaOrdenesOrigen[]
  ciotTipo?: string
  cittId?: number
  ciodFrecuenciahoras?: number
  ciodDuraciondias?: number
  ciodCantidadprescrita?: number
  mediId?: number
  ciodCantidaddosis?: number
  ciodCantidadpendiente?: number
  ciodTipoVia?: number
  ciodTipoUnidad?: number
  ciodTipoFormafarmaceutica?: number
  medicamento?: IMediMedicamentosGenericos
  via?: IConfMaestra
  unidad?: IConfMaestra
  formafarmaceutica?: IConfMaestra
  searchVia?: string
  searchUnidad?: string
  searchFormaFarmaceutica?: string
  hasDispensaciones?: boolean
  countAgendamientos?: number
  countAdmisiones?: number
  /** Solo en orders/search: 0/1, si el cups tiene contratos y si está en el de la orden. */
  tieneContratos?: number
  enContrato?: number
  ciodHabilitado?: number
}

export interface IResponseDispensacionesByOrden {
  ciot_id: number
  cire_id: number | null
  melo_nombre: string
  melo_laboratorio: string

  medi_nombre: string,
  medi_codigo: string,
  medi_principioactivo: string,
  medi_codigo_atc: string,
  medi_concentracion: string,
  medi_tipo_via: string,
  medi_tipo_presentacion: string,
  medi_tipo_unidad: string,
  medi_formafarmaceutica: string,

  citt_id: number
  citt_secundaria: number
  citt_cantidad: number
  citt_technologia: string
  citt_cod_technologia: string
  citt_fecha_entrega: string | null
  citt_hora: string
}

export type tipoGeneralesOrdenesIndex = {
  empresas: IConfPersonasEmpresa[]
  contratos: IConfContratos[]
  empleados: IConfPersonasEmpleado[]
}

export interface IEditarRecetarioForm {
  medicamento: IMediMedicamentosGenericos | null
  ciodFrecuenciahoras: number | null
  ciodDuraciondias: number | null
  ciodCantidaddosis: number | null
  ciodCantidadprescrita: number | null
  ciodObservacion: string
}

export interface IDistinctEntidadOrden {
  ciotEntidadOrden: string | null
  ciotNitIpsOrigen: string | null
}

export interface IDistinctProfesionalOrden {
  ciotMedOrden: string | null
  ciotRegistroMedico: string | null
  ciotMedTipoDocumento: number | null
  ciotMedDocumento: string | null
}

export interface IEntidadesProfesionalesExternas {
  entidades: IDistinctEntidadOrden[]
  profesionales: IDistinctProfesionalOrden[]
}

export interface IValidacionFormularioCups {
  compatible: boolean
  atendido: boolean
  tieneHistoria: boolean
  mensaje?: string
}